import React from 'react';
import {
    Box,
    Typography,
    Chip,
    Divider,
    ListItem
} from '@mui/material';

const statusColors = {
    executed: 'success',
    approved: 'info',
    'awaiting approval': 'warning',
    confirmed: 'primary',
    learning: 'secondary',
    'on hold': 'error',
    processing: 'default',
    'needs action': 'error',
    shared: 'info',
    logged: 'secondary',
    initiated: 'primary',
    ordered: 'success'
};

const WhookEventItem = ({ event, onClick }) => {
    if (!event) return null;

    return (
        <>
            <ListItem
                sx={{
                    alignItems: 'flex-start',
                    px: 0,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#1e1e1e' }
                }}
                onClick={() => onClick(event)}
            >
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="subtitle2" sx={{ color: '#12c099', fontWeight: 600 }}>
                            {event.time} — {event.agent}
                        </Typography>
                        <Chip
                            label={event.status}
                            size="small"
                            color={statusColors[event.status] || 'default'}
                            sx={{
                                textTransform: 'capitalize',
                                // --- START OF CHANGE ---
                                // If the status is 'processing', apply these specific styles
                                ...(event.status === 'processing' && {
                                    backgroundColor: 'white',
                                    color: 'black',
                                }),
                                // --- END OF CHANGE ---
                            }}
                        />
                    </Box>
                    <Typography variant="body2" sx={{ color: '#eee' }}>
                        {event.message}
                    </Typography>
                </Box>
            </ListItem>
            <Divider sx={{ borderColor: '#333' }} />
        </>
    );
};

export default WhookEventItem;
